import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

// Calls invalidateSize when splitSize changes so Leaflet re-tiles after panel drag
const MapResizer = ({ trigger }) => {
  const map = useMap();
  useEffect(() => { map.invalidateSize(); }, [map, trigger]);
  return null;
};

export default MapResizer;
